

































































































import Vue from 'vue';
import { mapActions } from 'vuex';
import { get } from 'vuex-pathify';
import { AxiosError } from 'axios';

import { ALForm } from '@/common/component.types';

import {
  IQuoteServiceTemplate,
  IQuoteServiceVariable,
  QuoteServiceVariable,
  QuoteServiceVariableFieldError
} from '@/models';

import ErrorAlert from '../common/ErrorAlert.vue';
import { ErrorManager } from '@/models/error';
import ALDialog from '../core/Dialog/ALDialog.vue';

export interface Options extends InstanceType<typeof Vue> {
  $refs: {
    form: ALForm;
  };
}

export default Vue.extend<Options>({
  functional: false
}).extend({
  name: 'QuoteServiceTemplateFormDialog',

  components: { ErrorAlert, ALDialog },

  data: () => ({
    loading: false,

    errorMessage: '',
    errorMessageDetail: '',

    serviceVariable: new QuoteServiceVariable(),
    serviceVariableOriginalCopy: new QuoteServiceVariable(),
    fieldError: new QuoteServiceVariableFieldError(),

    isEdit: false,
    dialog: false,
    serviceVariableFormValid: false
  }),

  computed: {
    quoteServiceTemplates: get<IQuoteServiceTemplate[]>(
      'quoteTemplate/getQuoteServiceTemplates'
    ),

    requiredRule() {
      return (field: string) => [(v: string) => !!v || `${field} is required`];
    }
  },

  mounted() {
    this.fetchQuoteServiceTemplates().catch(error => {
      if (error.response) {
        if (error.response.data.detail) {
          this.errorMessageDetail = error.response.data.detail;
        }
      }
      this.errorMessage = ErrorManager.extractApiError(error);
    });
  },

  methods: {
    ...mapActions({
      fetchQuoteServiceTemplates: 'quoteTemplate/fetchQuoteServiceTemplates',
      updateQuoteServiceVariable:
        'quoteServiceVariable/updateQuoteServiceVariable',
      createQuoteServiceVariable:
        'quoteServiceVariable/createQuoteServiceVariable'
    }),

    resetFormValidation(): void {
      if (this.$refs.form) {
        return this.$refs.form.resetValidation();
      }
    },

    validateForm(): boolean {
      let valid = false;
      if (this.$refs.form) {
        valid = this.$refs.form.validate();
      }
      return valid;
    },

    open(
      serviceVariable: IQuoteServiceVariable = new QuoteServiceVariable(),
      isEdit = false
    ) {
      this.loading = false;
      this.serviceVariableOriginalCopy = new QuoteServiceVariable(
        serviceVariable
      );
      this.serviceVariable = new QuoteServiceVariable(
        this.serviceVariableOriginalCopy
      );
      this.isEdit = isEdit;
      this.clearAllErrors();
      this.dialog = true;

      this.resetFormValidation();
    },

    clearAllErrors() {
      this.errorMessage = '';
      this.errorMessageDetail = '';
      this.fieldError.clearErrors();
    },

    close() {
      this.$refs.form.resetValidation();
      this.$nextTick(() => {
        this.dialog = false;
      });
    },

    async saveServiceVariable() {
      if (this.validateForm()) {
        this.clearAllErrors();

        this.loading = true;

        try {
          if (this.isEdit) {
            await this.updateQuoteServiceVariable(this.serviceVariable);
          } else {
            await this.createQuoteServiceVariable(this.serviceVariable);
          }
          this.close();
        } catch (err) {
          this.loading = false;
          const error = err as AxiosError;
          if (error.response) {
            if (error.response.data.detail) {
              this.errorMessage = error.response.data.detail;
            }
            // client received an error response that falls out of range 2xx
            if (
              QuoteServiceVariableFieldError.isQuoteServiceVariableFieldError(
                error.response.data
              )
            ) {
              this.fieldError = new QuoteServiceVariableFieldError(
                error.response.data
              );
            }
          }

          this.errorMessage = ErrorManager.extractApiError(error);
        }
      }
    }
  }
});
